import { getUserInfo } from "api/commonUtil";
import { sendGet } from "api/restUtil";
import { useEffect, useRef } from "react";


// 신규 주문 알림
export default function NewOrderNotification(props) {
	const audioChannel = new BroadcastChannel('notification_channel');

	const audioRef = useRef(new Audio('assets/sounds/order_notification.mp3'));
	const isAlert = useRef(false);

	useEffect(() => {
		if(!getUserInfo()?.branchId) {
			return;
		}
		const getCount = async() => {
			try {
				const lastPlayedTime = localStorage.getItem("last_played_time");
				const now = Date.now();
				if(lastPlayedTime && now - lastPlayedTime < 20*1000) {
					console.log("아직 20초 안됨");
					return;	// 이전 플레이에서 20초 지났을때만 플레이 하도록
				}

				const result = await sendGet("/api/order/new-ordr-count", null, false);
				if(result.respCode === "SUCCESS") {
					if(result.data > 0)
					audioRef.current.play()
					.then(() => {
						audioChannel.postMessage({ type: 'PLAYED', time: now });
					})
					.catch(e => {
						alert("신규 주문이 있습니다.");
						return;
					});
				}
			} catch(e) {
				if(!isAlert.current) {
					isAlert.current = true;
					alert("신규 주문 확인 실패. 새로고침 해 주세요.\n현재 메시지가 계속 표시되면 관리자에게 문의해 주세요.");
				}
			}
		}

		getCount();
		const interval = setInterval(getCount, 30 * 1000);

		audioChannel.onmessage = (e) => {
			if(e.data.type === "PLAYED") {
				localStorage.setItem("last_played_time", e.data.time);
			}
		}
		return () => {
			clearInterval(interval);
		}
	}, [getUserInfo()?.branchId]);

}